<template>
    <div class="living-options-property-models">
      <div class="row">
        <div class="col-12">
          <div class="property-models">
            <h5>Property Models</h5>
            <button class="btn btn-primary mb-4" @click="addPropertyModel()" :disabled="isAddingNewObject('propertyModels')">Add Property Model</button>
            <div>
              Filter Property Models
              <input class="mb-4" type="text" v-model="propertyModelFilterText" placeholder="Juman One">
            </div>
            
            <table>
              <thead>
                <tr>
                  <th>Label</th>
                  <th>Type</th>
                  <th>Bedrooms</th>
                  <th>Bathrooms</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="propertyModel in filteredPropertyModels"
                  :key="propertyModel._id"
                >
                  <td>{{ propertyModel.label }}</td>
                  <td>{{ propertyModel.type }}</td>
                  <td>{{ propertyModel.beds }}</td>
                  <td>{{ propertyModel.baths }}</td>
                  <td class="text-right table__button-cell"><button class="btn btn-sm btn-outline-secondary" @click="activePropertyModelId = propertyModel._id">Edit</button></td>
                </tr>
              </tbody>
            </table>
            <modal-popup :isVisible="!!activePropertyModel">
              <div v-if="activePropertyModel" class="row modal-row-padding" v-click-outside="closeModal">
                <div class="col-3">
                  <fieldset class="form-group">
                    <label>Label</label>
                    <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.label }}</div>
                    <input
                      v-else
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activePropertyModel.label"
                      placeholder="i.e. apartment"
                      :disabled="activePropertyModelId !== activePropertyModel._id"
                    />
                  </fieldset>
                </div>
                <div class="col-3">
                  <fieldset class="form-group">
                    <label>Type</label>
                    <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.type }}</div>
                    <input
                      v-else
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activePropertyModel.type"
                      placeholder="i.e. apartment"
                      :disabled="activePropertyModelId !== activePropertyModel._id"
                    />
                  </fieldset>
                </div>
                <div class="col-3">
                  <fieldset class="form-group">
                    <label>Bedrooms</label>
                    <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.beds }}</div>
                    <input
                      v-else
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activePropertyModel.beds"
                      placeholder="i.e. 2"
                    />
                  </fieldset>
                </div>
                <div class="col-3">
                  <fieldset class="form-group">
                    <label>Bathrooms</label>
                    <div v-if="activePropertyModelId !== activePropertyModel._id">{{ activePropertyModel.baths }}</div>
                    <input
                      v-else
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activePropertyModel.baths"
                      placeholder="i.e. 1"
                      :disabled="activePropertyModelId !== activePropertyModel._id"
                    />
                  </fieldset>                                                    
                </div>
                <div class="col-6" v-if="activePropertyModelId === activePropertyModel._id">
                  <fieldset class="form-group">
                    <label>Floorplan</label>
                    <input-asset v-model="activePropertyModel.floorplans" :multiple="true"></input-asset>
                  </fieldset>
                </div>
                <div class="col-6" v-if="activePropertyModelId === activePropertyModel._id">
                  <!-- <button @click="propertyModel.images.push(null)">Add Image</button> -->
                  <fieldset class="form-group">
                    <label>Gallery Images</label>
                    <input-asset v-model="activePropertyModel.images" :multiple="true"></input-asset>
                  </fieldset>
                </div>
                <div class="col-12">
                  <button v-if="activePropertyModelId !== activePropertyModel._id" class="" @click="activePropertyModelId = activePropertyModel._id">Edit</button>
                  <button v-if="activePropertyModelId === activePropertyModel._id" class="btn btn-sm btn-outline-danger" @click="activePropertyModelId = null">Cancel</button>
                  <button v-if="activePropertyModelId === activePropertyModel._id" class="btn btn-sm btn-primary ml-1" @click="saveActivePropertyModel()">Save</button>
                </div>
              </div>             
            </modal-popup>
          </div>
        </div>
      </div>
    </div>     
</template>
<script>
import _ from 'lodash'
import InputAsset from '@/components/InputAsset'
import InputMultiSelect from '@/components/InputMultiSelect'
import ModalPopup from '@/components/ModalPopup'

export default {
  components: { InputAsset, InputMultiSelect, ModalPopup },
  data () {
    return {
      activePropertyModelId: null,
      propertyModelFilterText: '',
    }
  },

  computed: {
    activePropertyModel () {
      return _.find(this.propertyModels, propertyModel => {
        return propertyModel._id === this.activePropertyModelId
      })
    },

    filteredPropertyModels () {
      return _.filter(this.propertyModels, propertyModel => {
        return propertyModel.label.toLowerCase().includes(this.propertyModelFilterText.toLowerCase())
      })
    },

    propertyModels: {
      get () {
        return this.$store.getters.propertyModels
      },
      set (properties) {
        this.$store.commit('SET_PROPERTY_MODELS', propertyModels)
      }
    },
  },

  methods: {
    addPropertyModel () {
      const propertyModel = {
        _id: 'temp',
        label: '',
        displayName: '',
        type: '',
        beds: '',
        baths: '',
        floorplans: [],
        images: []
      }
      this.$store.commit('ADD_PROPERTY_MODEL', propertyModel)
      this.activePropertyModelId = propertyModel._id
    },

    closeModal () {
      this.activePropertyModelId = null
    },

    isAddingNewObject () {
      return Boolean(_.map(this.propertyModels, propertyModel => { return propertyModel._id }).includes('temp'))
    },

    saveActivePropertyModel () {
      this.$store.dispatch('SAVE_PROPERTY_MODEL', this.activePropertyModel)
      this.activePropertyModelId = null
    },
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_PROPERTY_MODELS')
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";

  select {
    width: 100%;
  }

  .card {
    z-index: unset !important;
  }

  .living-option, .subsection, .property, .property-model {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;
    margin: 1em 0;
  }

  .selection-list {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;   
    max-height: 200px;
    // overflow: scroll; 
  }

  .list-wrapper {
    max-height: 600px;
    // overflow: scroll;
  }

  .living-options-property-models {
    table {
      border-collapse: separate;
      border-spacing: 0;
      border: 1px solid #d4d4d4;
      border-radius: 6px;
      // overflow: hidden;
      width: 100%;
    }

    .table__button-cell button {
      opacity: 0;
    }

    tbody {
      display: block;
      max-height: none;
      overflow: auto;

      @include v-breakpoint(800px) {
        max-height: calc(100vh - 500px);
      }

      tr:hover {
        background-color: #f5f5f5;
        .table__button-cell button {
          opacity: 1;
        }
      }
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    thead {
      background-color: #f0f0f0;
      border-bottom: 1px solid #d4d4d4;
      font-size: 12px;
      position: sticky;
      text-transform: uppercase;
      top: 0;
      z-index: 10;
    }

    th, td {
      font-weight: 400;
      padding: 10px 15px;
    }

    tr {
      &:nth-child(2n) {
        background-color: #fafafa;
      }
    }
  }

  .modal-row-padding {
    padding: 30px 0;
  }
</style>